export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6279.56da55c0.jpg";